import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query/react';
import { apis } from './apis/apis';
import { authReducer } from './features/auth-slice';
import { messageReducer } from './features/message-slice';

export const store = configureStore({
  reducer: {
    [apis.reducerPath]: apis.reducer,
    auth: authReducer,
    message: messageReducer,
  },
  middleware: (getDefaultMiddleare) => getDefaultMiddleare().concat(apis.middleware),
});

setupListeners(store.dispatch);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppStore = ReturnType<typeof configureStore>;
